import React from 'react';

const Help = ({ className, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      className={className}
      {...props}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99967 2.66659C5.05416 2.66659 2.66634 5.0544 2.66634 7.99992C2.66634 10.9454 5.05416 13.3333 7.99967 13.3333C10.9452 13.3333 13.333 10.9454 13.333 7.99992C13.333 5.0544 10.9452 2.66659 7.99967 2.66659ZM1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99967 10.6616C8.36786 10.6616 8.66634 10.9601 8.66634 11.3283V11.3349C8.66634 11.7031 8.36786 12.0016 7.99967 12.0016C7.63148 12.0016 7.33301 11.7031 7.33301 11.3349V11.3283C7.33301 10.9601 7.63148 10.6616 7.99967 10.6616Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.98285 4.22299C7.31578 4.05825 7.68241 3.97304 8.05387 3.97407C8.42534 3.9751 8.79149 4.06235 9.12351 4.22893C9.45552 4.39551 9.74434 4.63689 9.96722 4.93406C10.1901 5.23123 10.341 5.57608 10.4079 5.94146C10.4749 6.30684 10.4561 6.68278 10.3531 7.03967C10.2501 7.39656 10.0656 7.72467 9.81422 7.99816C9.56285 8.27165 9.25142 8.48306 8.90447 8.61574C8.89884 8.61789 8.89318 8.61997 8.88749 8.62197C8.81933 8.64594 8.7608 8.6914 8.72072 8.75152C8.68064 8.81164 8.66118 8.88316 8.66527 8.9553C8.68612 9.3229 8.40502 9.6378 8.03743 9.65865C7.66983 9.67949 7.35493 9.3984 7.33408 9.0308C7.31362 8.6701 7.41092 8.31252 7.61132 8.01192C7.80964 7.71444 8.09831 7.48871 8.43459 7.3679C8.58624 7.30879 8.72237 7.21575 8.83255 7.09588C8.94427 6.97433 9.02626 6.82851 9.07204 6.66989C9.11783 6.51127 9.12617 6.34419 9.09641 6.1818C9.06665 6.01941 8.99961 5.86614 8.90055 5.73407C8.80149 5.60199 8.67313 5.49471 8.52557 5.42067C8.37801 5.34663 8.21527 5.30786 8.05018 5.3074C7.88508 5.30694 7.72213 5.34482 7.57416 5.41803C7.42619 5.49125 7.29724 5.59782 7.19745 5.72934C6.9749 6.02266 6.55671 6.08004 6.26339 5.85749C5.97007 5.63495 5.91269 5.21676 6.13524 4.92343C6.35976 4.62751 6.64991 4.38773 6.98285 4.22299Z"
        fill="currentColor"
      />
    </svg>
  );

export default Help;
